import styled from 'styled-components';
import {respondTo} from '../../../styles'

export const LinksContainer = styled.div`
  margin-bottom: auto;
  display: none;
  ${respondTo.md`
  display: block;
  `}
`;